import React, { useEffect, useState } from 'react';

export default function DelayChild({ delay = 3000, children }) {
  const [showChild, setShowChild] = useState(false);

  useEffect(() => {
    let timeoutVar;

    if (delay) {
      timeoutVar = setTimeout(() => setShowChild(true), delay);
    } else if (!delay) {
      timeoutVar && clearTimeout(timeoutVar);
      setShowChild(true);
    }

    return () => timeoutVar && clearTimeout(timeoutVar);
  }, [delay]);

  return showChild ? children : <></>;
}
